<template>
  <div class="personal_certificate">
    <pcHeader></pcHeader>
    <div class="inside_box">
      <div class="inside">
        <div class="heading">{{ $t('message.news.personalCertification') }}</div>
        <div class="form">
          <van-form ref="form" label-width="75">
            <div class="card_box">
              <div class="identity_card_label"><span>*</span> {{ $t('message.news.iDCard') }}</div>
              <!-- :rules="[{ required: true, message: '请上传身份证/护照正面' }]" -->
              <van-field
                class="identity_card"
                style="margin-right: 10px"
                name="uploader"
                :rules="[{ required: true, message: $t('message.news.clickIDCard') }]"
              >
                <template #input>
                  <van-uploader
                    max-count="1"
                    :upload-icon="$t('message.news.idFrontalView')"
                    v-model="fileList"
                    :after-read="afterRead"
                  ></van-uploader>
                </template>
              </van-field>
              <!-- :rules="[{ required: true, message: '请上传身份证/护照背面' }]" -->
              <van-field
                class="identity_card"
                name="uploader"
                :rules="[{ required: true, message: $t('message.news.clicEmblemCard') }]"
              >
                <template #input>
                  <van-uploader
                    max-count="1"
                    :upload-icon="$t('message.news.idBacksidePhotograph')"
                    v-model="fileListTwo"
                    :after-read="afterReadTwo"
                  ></van-uploader>
                </template>
              </van-field>
            </div>

            <div class="label_box">
              <div class="label_box_label"><span>*</span>{{ $t('message.news.realName') }}：</div>
              <!-- :rules="[{ required: true, message: '请输入真实姓名' }]" -->
              <van-field
                v-model="queryInfo.realName"
                :placeholder="$t('message.news.identified')"
                readonly
                :rules="[{ required: true, message: $t('message.news.identified') }]"
                style="border: 1px solid #efefef; width: 324px"
              />
            </div>
            <!-- :rules="[{ required: true, message: '请输入身份证号' }]" -->
            <div class="label_box">
              <div class="label_box_label"><span>*</span>{{ $t('message.news.iDNumber') }}：</div>
              <van-field
                v-model="queryInfo.identificationNumber"
                :placeholder="$t('message.news.identified')"
                readonly
                :rules="[{ required: true, message: $t('message.news.identified') }]"
                style="border: 1px solid #efefef; width: 324px"
              />
            </div>

            <div class="label_box">
              <div class="label_box_label">
                <span>*</span>{{ $t('message.news.mailingAddress') }}：
              </div>
              <van-field
                v-model="queryInfo.mailingAddress"
                :placeholder="$t('message.news.PleaseAddress')"
                :rules="[{ required: true, message: $t('message.news.PleaseAddress') }]"
                style="border: 1px solid #efefef; width: 324px"
              />
            </div>

            <div>
              <VuePhoneNumberInput
                v-model="phone"
                @update="validate"
                :translations="translations"
                class="phoneNumber"
                :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
              />
            </div>
            <div class="uploader_title"><span>*</span>{{ $t('message.news.pleaseWorks') }}</div>
            <van-field
              class="upload_img"
              name="uploader"
              :rules="[{ required: true, message: $t('message.news.pleaseWorks') }]"
            >
              <template #input>
                <div class="flex">
                  <van-uploader
                    v-model="imgList"
                    max-count="5"
                    multiple
                    :after-read="afterReadNew"
                    accept=".jpg,.png"
                    :before-delete="beforeDelete"
                    :max-size="isOverSize"
                  />
                </div>
              </template>
            </van-field>
            <div class="img_upload_hint">
              <van-icon name="warning" style="margin-right: 4px" />
              <span> {{ $t('message.news.supportedFormats') }}</span>
            </div>
          </van-form>
          <div class="div">
            <van-checkbox icon-size="16px" v-model="checkedAgges"
              ><div class="aggess">
                {{ $t('message.news.ihaveRead')
                }}<span @click="showClickTxt"> {{ $t('message.news.signingAgreement') }}</span>
              </div></van-checkbox
            >
          </div>
        </div>

        <div>
          <van-popup v-model="showTxt" class="text_pop">
            <txt-pop />
          </van-popup>
          <div class="remove1" v-if="showTxt" @click="showTxt = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="btn">
          <van-button @click="btn" :disabled="display">{{
            $t('message.activity_upload_works.submit')
          }}</van-button>
        </div>

        <div class="toast" v-if="toastShow">
          <div class="toastIcon">
            <div class="toastIcon_box">
              <van-icon name="success" size="24" color="rgba(26, 26, 26, 0.4)" />
            </div>
          </div>
          <div class="toastTxt">{{ $t('message.news.submittedTip') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pcHeader from '../../../../components/pcHeader.vue'
import { Toast } from 'vant'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { getIdentityCard, saveIdentityCard, queryByIds } from '../../../../api/user.js'
import { client } from '../../../../utils/oss'
import { getCookie } from '@/utils/cookie'
import { selectCertificationInfo } from '@/api/journalism.js'
import TxtPop from './common/TxtPop.vue'

export default {
  components: { VuePhoneNumberInput, pcHeader, TxtPop },
  data() {
    return {
      fileList: [],
      fileListTwo: [],
      display: false,
      queryInfo: {
        auditStatus: 1,
        certificationType: '1', // 认证类型（1：个人认证，2：企业认证）
        contacts: '', // 联系人
        organizationName: '', // 组织名称
        createId: 0,
        createTime: '',
        identificationBack: '', // 身份证反面图
        identificationFront: '', // 身份证正面图
        identificationNumber: '', // 身份证号码
        identificationValidityPeriod: '', // 身份证有效日期
        mailingAddress: '', // 邮寄地址
        mobile: '', // 不带区码的手机号
        realName: '', // 真实姓名
        updateId: 0,
        updateTime: '',
        userId: 0, // 用户id
        works: '', // 作品
        worksList: [] // 作品集合
      },
      phone: '',
      imgList: [],
      // 上传不规范图片定时器
      uploadTime: null,
      // 上传图片格式不规范的图片名字
      filesListName: [],
      // 上传图片大小不规范的图片名字
      filesListSize: [],
      translations: {
        // countrySelectorLabel: '中国',
        // countrySelectorError: '请选择国家',
        // phoneNumberLabel: '手机号码',
        // example: '示例 :'
      },
      checkedAgges: true,
      uploadImgList: [],
      showTxt: false,
      toastShow: false
    }
  },
  computed: {
    state() {
      return this.$route.query.state
    }
  },
  watch: {},
  created() {
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
    this.getUserInfo()
    this.getSelectCertificationInfo()
  },
  methods: {
    sss() {
      alert(77)
    },
    showClickTxt() {
      this.showTxt = true
    },
    async getSelectCertificationInfo() {
      let query = {
        auditStatus: '',
        mobile: '',
        nickName: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        realName: '',
        userId: getCookie('userId')
      }
      const { data: res } = await selectCertificationInfo(query)
      if (res.resultCode == 200) {
        if (
          this.state == 2 &&
          res.data.list[0] &&
          res.data.list[0].worksList &&
          res.data.list[0].worksList.length == 5
        ) {
          this.queryInfo.identificationFront = res.data.list[0].identificationFront.split(
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
          )[1]
          this.queryInfo.identificationBack = res.data.list[0].identificationBack.split(
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
          )[1]
          this.fileList.push({
            url: res.data.list[0].identificationBack
          })

          this.fileListTwo.push({
            url: res.data.list[0].identificationFront
          })

          this.queryInfo.realName = res.data.list[0].realName
          this.queryInfo.identificationNumber = res.data.list[0].identificationNumber
          this.queryInfo.identificationValidityPeriod =
            res.data.list[0].identificationValidityPeriod
          this.queryInfo.mailingAddress = res.data.list[0].mailingAddress
          this.queryInfo.mobile = res.data.list[0].mobile
          this.phone = res.data.list[0].mobile

          res.data.list[0].worksList.forEach((item, index) => {
            this.queryInfo.worksList.push(
              item.split('https://imagecharacter.oss-cn-beijing.aliyuncs.com/')[1]
            )
          })
          res.data.list[0].worksList.forEach((item) => {
            this.imgList.push({
              url: item
            })
          })
        }
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const { data: res } = await queryByIds({
        id: getCookie('userId')
      })
      if (res.resultCode == 200) {
        this.phone = res.data.mobile
        this.queryInfo.mobile = res.data.mobile
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    },

    afterRead(file) {
      //  随机得到一个数字大小写字母的字符串
      let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let a = t.length
      let n = process.env.VUE_APP_UPLOAD_API
      for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
      n = n + this.initDay()
      let sub = file.file.name.split('.')
      n = n + '.' + sub[sub.length - 1]
      var names = file.file.name.replace(/ +/g, '')
      var name = names.replace(/\+/g, '')
      name = name.replace(/#/g, '-')
      name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
      var getName = process.env.VUE_APP_UPLOAD_API + name
      var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
      // console.log(n)
      client()
        .multipartUpload(n, file.file)
        .then(async (res) => {
          let str = res.res.requestUrls[0].split('?')[0]
          const msg = await getIdentityCard({
            url: str
          })
          if (msg.data.resultCode == 200) {
            this.queryInfo.identificationBack = n
            this.queryInfo.identificationNumber = msg.data.data.code
            this.queryInfo.realName = msg.data.data.name
          } else {
            this.fileList = []
            return Toast('识别身份证信息失败，请重新上传后重试!')
          }
        })
        .catch((err) => {
          // console.log(err)
        })
    },

    afterReadTwo(file) {
      //  随机得到一个数字大小写字母的字符串
      let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let a = t.length
      let n = process.env.VUE_APP_UPLOAD_API
      for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
      n = n + this.initDay()
      let sub = file.file.name.split('.')
      n = n + '.' + sub[sub.length - 1]
      var names = file.file.name.replace(/ +/g, '')
      var name = names.replace(/\+/g, '')
      name = name.replace(/#/g, '-')
      name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
      var getName = process.env.VUE_APP_UPLOAD_API + name
      var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
      // console.log(n)
      client()
        .multipartUpload(n, file.file)
        .then(async (res) => {
          let str = res.res.requestUrls[0].split('?')[0]
          const msg = await getIdentityCard({
            url: str
          })
          if (msg.data.resultCode == 200) {
            this.queryInfo.identificationFront = n
            let time = msg.data.data.validPeriod.split('-')[1]
            time = time.split('.')[0] + '-' + time.split('.')[1] + '-' + time.split('.')[2]
            this.queryInfo.identificationValidityPeriod = time
          } else {
            this.fileList = []
            return Toast('识别身份证信息失败，请重新上传后重试!')
          }
        })
        .catch((err) => {
          // console.log(err)
        })
    },

    btn() {
      if (this.checkedAgges) {
        if (this.imgList.length < 5) {
          return Toast('请上传规定数量的图片后重试')
        }
        this.$refs.form
          .validate()
          .then(() => {
            this.submitClick()
          })
          .catch(() => {
            this.$toast.fail(this.$t('message.activity_upload_works.complete'))
          })
      } else {
        this.$toast.fail(this.$t('message.activity_upload_works.tick_privacy'))
      }
      // if (this.imgList.length < 5) {
      //   return Toast('请上传规定数量的图片后重试')
      // }
      // this.$refs.form
      //   .validate()
      //   .then(() => {
      //     this.submitClick()
      //   })
      //   .catch(() => {
      //     this.$toast.fail(this.$t('message.activity_upload_works.complete'))
      //   })
    },
    async submitClick() {
      this.display = true
      this.queryInfo.userId = getCookie('userId')
      this.queryInfo.worksList = this.uploadImgList
      const { data: res } = await saveIdentityCard(this.queryInfo)
      if (res.resultCode == 200) {
        this.toastShow = true
        this.display = false
        setTimeout(() => {
          this.toastShow = false
          this.$router.go(-1)
        }, 1000)
      } else {
        this.display = false
        Toast('网络繁忙，请稍候重试！')
      }
    },
    validate(val) {
      this.queryInfo.mobile = val.nationalNumber
    },
    //上传图片
    afterReadNew(file) {
      if (file instanceof Array) {
        //  多图
        file.map((el) => {
          let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
          let a = t.length
          let n = process.env.VUE_APP_UPLOAD_API
          for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
          n = n + this.initDay()
          let sub = el.file.name.split('.')
          n = n + '.' + sub[sub.length - 1]
          var names = el.file.name.replace(/ +/g, '')
          var name = names.replace(/\+/g, '')
          name = name.replace(/#/g, '-')
          name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
          var getName = process.env.VUE_APP_UPLOAD_API + name
          var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
          client()
            .multipartUpload(n, el.file)
            .then((res) => {
              // console.log(res.res.requestUrls)
              // let str = res.res.requestUrls[0].split('?')[0]
              this.uploadImgList.push(n)
            })
            .catch((err) => {
              // console.log(err)
            })
        })
      } else {
        //  随机得到一个数字大小写字母的字符串
        let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let a = t.length
        let n = process.env.VUE_APP_UPLOAD_API
        for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
        n = n + this.initDay()
        let sub = file.file.name.split('.')
        n = n + '.' + sub[sub.length - 1]

        // 单图
        this.rate = 0
        var names = file.file.name.replace(/ +/g, '')
        var name = names.replace(/\+/g, '')
        name = name.replace(/#/g, '-')
        name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
        var getName = process.env.VUE_APP_UPLOAD_API + name
        var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
        // console.log(n)
        client()
          .multipartUpload(n, file.file)
          .then((res) => {
            // let str = res.res.requestUrls[0].split('?')[0]
            // console.log(str)
            this.uploadImgList.push(n)
          })
          .catch((err) => {
            // console.log(err)
          })
      }
    },

    beforeDelete(file, fileList) {
      this.uploadImgList.splice(fileList.index, 1)
      return true
    },
    initDay() {
      const date = new Date().getTime() // 得到当前时间
      return `-${date}`
    },
    // 上传图片限制
    isOverSize(file) {
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      let re = false
      const imgFormat = /image\/(jpeg|jpg|png)$/
      const type = file.type
      const size = file.size / 1024 / 1024 > 10
      // console.log(file.size)
      // 图片格式判断
      if (!imgFormat.test(type)) {
        this.filesListName.push(file.name + '\n')
        re = true
      }
      // 图片大小判断
      // console.log(size)
      if (size) {
        this.filesListSize.push(file.name + '\n')
        re = true
      }
      // console.log(this.filesListName)
      this.uploadTime = setTimeout(() => {
        this.uploadImgLose()
        this.filesListName = []
        this.filesListSize = []
      }, 100)
      return re
    },
    // 上传不规范图片提示
    uploadImgLose() {
      // 清除定时器
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      // 图片类型
      let filesListNameS = []
      // 图片大小
      let filesListSizeS = []

      filesListNameS = [...new Set(this.filesListName)]
      filesListSizeS = [...new Set(this.filesListSize)]

      if (filesListNameS.length != 0) {
        Toast({
          message: '以下图片格式不正确\n' + filesListNameS.join('')
        })
      }
      if (filesListSizeS.length != 0) {
        Toast({
          message: '以下图片大小不能大于10M\n' + filesListSizeS.join('')
        })
      }
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.personal_certificate {
  background-color: #f7f8fa;
  .inside_box {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .inside {
    width: 80%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .heading {
      height: 134px;
      color: #263245;
      font-size: 18px;
      font-weight: 700;
      line-height: 134px;
    }
  }
  .head_title {
    font-size: 16px;
    color: #151515;

    /deep/.van-icon {
      color: #515151;
    }
  }

  .form {
    padding: 24px 20px 0;
    width: 460px;

    .uploader_title {
      font-size: 14px;
      color: #1a1a1a;
      height: 52px;
      line-height: 52px;
      span {
        color: #e34747;
      }
    }

    /deep/ .van-uploader__upload,
    /deep/ .van-image,
    /deep/ .van-uploader__preview-image {
      width: 185px;
      height: 113px;
    }
    /deep/.van-uploader {
      width: 100%;
    }
    /deep/.van-uploader__preview {
      width: 100%;
    }
    /deep/ .van-icon__image {
      width: 185px;
      height: 113px;
    }
    // /deep/ .van-uploader__upload,
    // /deep/ .van-image {
    //   border-radius: 19px;
    // }
    /deep/ .van-uploader__upload {
      border-radius: 19px;
    }
    .card_box {
      display: flex;
    }
    .label_box {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .label_box_label {
        font-size: 14px;
        color: #1a1a1a;
        font-weight: 400;
        // margin-right: 10px;
        span {
          color: #e34747;
        }
      }
    }
    .identity_card_label {
      font-size: 14px;
      color: #1a1a1a;
      font-weight: 400;
      margin-right: 10px;
      span {
        color: #e34747;
      }
    }
    .identity_card {
      padding: 0 !important;
    }
    /deep/.van-cell {
      // padding: 10px 0;
      width: auto;
    }
    .van-cell::after {
      border-bottom: none;
    }
    /deep/.van-uploader__upload {
      margin: 0 0 16px 0;
    }
    /deep/.van-cell--required::before {
      left: -7px;
    }

    .phoneNumber {
      width: 345px !important;
      margin: 0 auto;
      flex-direction: row !important;
    }

    .vue-phone-number-input {
      // padding: 0 16px 0 0;
      margin: 0;
      /deep/.input-tel__input {
        border: 0;
        border-bottom: 1px solid #ccc !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
      /deep/.country-selector__input {
        border: 0;
        border-bottom: 1px solid #ccc !important;
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
      }
    }
  }
  .div {
    box-sizing: border-box;
    // width: 32.5%;
    // width: 495px !;

    overflow: hidden;
    padding: 10px 0px 10px 0px;
    background-color: #fff;

    .aggess {
      display: flex;
      align-items: center;
      color: #263245;
      font-size: 12px;
      font-weight: 400;

      span {
        color: #3360ff;
      }
    }
  }
  .btn {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    padding: 60px 16px 30px 16px;
    background-color: #fff;
    text-align: center;

    button {
      width: 178px;
      border-radius: 18px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      padding: 0;
      border: none;
      background-color: #3562ff;
      box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);
      color: #fff;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .toast {
    width: 265px;
    height: 84px;
    border-radius: 4px;
    background-color: rgba(26, 26, 26, 0.4);
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #ffffff;
    display: flex;
    .toastIcon {
      width: 62px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .toastIcon_box {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .toastTxt {
      width: 198px;
      line-height: 22.4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .img_upload_hint {
    font-size: 11px;
    color: #999999;
  }
  .text_pop {
    width: 90%;
    height: 80%;
    border-radius: 12px;
  }
}
.upload_img {
  // width: 185px !important;
  padding: 10px 16px 10px 0px;
  /deep/.van-uploader__preview {
    display: flex;
    width: auto !important;
  }
}
</style>
